module.exports = __webpack_public_path__ + "assets/images/card-pg-10_08b7ec10d981e642972834d721aa58a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main/card-pg-10.png
// module id = 197
// module chunks = 0